<template>
  <router-view name="brand" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Brand",
};
</script>
